import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';

export const paragraphCommand = ({ editor, range }) =>
  range ? editor.chain().focus().deleteRange(range).setParagraph().run() : editor.chain().focus().setParagraph().run();

const Paragraph = ({ editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${indicateActive && editor.isActive('paragraph') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<div className="text-gray-800 text-xs font-weight-500">A</div>}
      onClick={isExtension ? () => {} : () => paragraphCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="PARAGRAPH" defaultMessage="Paragraph" />
        </div>
      )}
    </Button>
  );
};

export default Paragraph;
